export default __webpack_public_path__ + "static/media/confiar.94b68de6.svg";